import { CdkScrollableModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { DrawerBottomContainerComponent } from './drawer-bottom/drawer-bottom-container.component';
import { DrawerBottomComponent } from './drawer-bottom/drawer-bottom.component';
import { DrawerContainerComponent } from './drawer-standard/drawer-container.component';
import { DrawerContentComponent } from './drawer-standard/drawer-content.component';
import { DrawerComponent } from './drawer-standard/drawer.component';

const publicApi = [
  DrawerBottomComponent,
  DrawerBottomContainerComponent,
  DrawerComponent,
  DrawerContainerComponent,
  DrawerContentComponent,
];

@NgModule({
  imports: [CommonModule, CdkScrollableModule],
  declarations: [...publicApi],
  exports: [...publicApi],
})
export class DrawerModule {}
